import { render, staticRenderFns } from "./CustomerIngredientCreate.vue?vue&type=template&id=1fc6de45"
import script from "./CustomerIngredientCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerIngredientCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports